// einheit_eigentuemer hat seit 13.10.2026 Historie: mehrere Zeilen je Einheit (Vorbesitzer
// mit vertrag_bis, geplante Übernahme mit vertrag_ab in der Zukunft, Miteigentümer).
// Wer eine Einheit „hat“, entscheidet die Laufzeit am Stichtag.

export interface EinheitEigZeitraum {
  vertrag_ab?: string | null;
  vertrag_bis?: string | null;
}

const tag = (s: string | null | undefined): string | null => (s && /^\d{4}-\d{2}-\d{2}/.test(s) ? s.slice(0, 10) : null);

/** Läuft am Stichtag: begonnen (oder ohne Beginn) und nicht beendet. */
export function istAktuell(z: EinheitEigZeitraum, heute: string): boolean {
  const ab = tag(z.vertrag_ab);
  const bis = tag(z.vertrag_bis);
  return (!ab || ab <= heute) && (!bis || bis >= heute);
}

/** Beginnt erst nach dem Stichtag (geplante Übernahme). */
export function istGeplant(z: EinheitEigZeitraum, heute: string): boolean {
  const ab = tag(z.vertrag_ab);
  return !!ab && ab > heute;
}

/**
 * Hauptzeile einer Einheit am Stichtag (für Ansichten mit genau einem Eigentümer, MEA, Hausgeld):
 * laufende Zeilen, bevorzugt mit MEA/Hausgeld, dann die älteste.
 */
export function aktuelleZeile<T extends EinheitEigZeitraum & { mea?: unknown; hausgeld_vorschuss?: unknown }>(zeilen: readonly T[], heute: string): T | null {
  const laufend = zeilen.filter(z => istAktuell(z, heute));
  if (laufend.length === 0) return null;
  const gewicht = (z: T) => (z.mea !== null && z.mea !== undefined ? 2 : 0) + (z.hausgeld_vorschuss !== null && z.hausgeld_vorschuss !== undefined ? 1 : 0);
  return [...laufend].sort((a, b) => gewicht(b) - gewicht(a) || (tag(a.vertrag_ab) ?? '').localeCompare(tag(b.vertrag_ab) ?? ''))[0] ?? null;
}

/** Je Einheit die Hauptzeile am Stichtag. */
export function aktuelleJeEinheit<T extends EinheitEigZeitraum & { einheit_id: string; mea?: unknown; hausgeld_vorschuss?: unknown }>(zeilen: readonly T[], heute: string): T[] {
  const gruppen = new Map<string, T[]>();
  for (const z of zeilen) gruppen.set(z.einheit_id, [...(gruppen.get(z.einheit_id) ?? []), z]);
  return [...gruppen.values()].flatMap(g => {
    const z = aktuelleZeile(g, heute);
    return z ? [z] : [];
  });
}
